import React from 'react'
import { Panel, Message } from 'rsuite'
import { Button, Icon, ButtonToolbar } from 'rsuite'
import UserDataTable from './UserDataTable'

export default function UserListSubProjectWidgets({ ...props }) {
  const { onEdit, onRemove, onCreate, loading, schema, deleteError, setDeleteError } = props
  // const [formSchema, setFormSchema] = useState(_schema)

  // const { projectId } = useParams()

  // useEffect(() => {
  //   console.log('load ProjectName projectId', projectId)
  //   // setFormSchema(_schema)
  // }, [])

  return (
    <>
      <Panel shaded header={schema.header} collapsible defaultExpanded>
        <ButtonToolbar style={{ marginBottom: '5px' }}>
          <Button appearance="primary" onClick={onCreate}>
            <Icon icon="plus-square" style={{ paddingRight: '5px' }} />
            {schema.buttonText}
          </Button>
        </ButtonToolbar>
        {deleteError && (
          <Message
            type="error"
            showIcon
            closable
            description={deleteError}
            style={{ marginBottom: 10 }}
            onClose={() => {
              setDeleteError('')
            }}
          />
        )}
        <UserDataTable
          schema={schema}
          pagination={true}
          // onReload={onReload}
          onEdit={onEdit}
          onRemove={onRemove}
          loading={loading}
        />
      </Panel>
    </>
  )
}
